import { render, staticRenderFns } from "./ProjectPublishTargetSelectorPopupWrappable.vue?vue&type=template&id=5f8c8dd9&scoped=true&lang=pug&"
import script from "./ProjectPublishTargetSelectorPopupWrappable.vue?vue&type=script&lang=js&"
export * from "./ProjectPublishTargetSelectorPopupWrappable.vue?vue&type=script&lang=js&"
import style0 from "./ProjectPublishTargetSelectorPopupWrappable.vue?vue&type=style&index=0&id=5f8c8dd9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8c8dd9",
  null
  
)

export default component.exports